import React, { Component } from 'react';
import Social from '../components/Social';

class Contact extends Component {
  render() {
    return (
    <div className="condiv">
      <h1 className="subtopic">Contact Me</h1>
      <h3>Email  :   mailadeleketemitayo@gmail.com</h3>
      <h3> GitHub: <a href="https://github.com/lekegitrepo" target="_blank">@lekegitrepo</a></h3>
      <h3>LinkedIn: <a href="https://www.linkedin.com/in/temitayo-adeleke/" target="_blank">Temitayo Adeleke</a> </h3>
      <h3> Twitter: <a href="https://twitter.com/leketemi" target="_blank">@leketemi</a></h3>      
      <Social />
    </div>
    );
  }
}

export default Contact;
